"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Step = void 0;
const shared_models_1 = require("@railgun-community/shared-models");
const filters_1 = require("../utils/filters");
const step_validator_1 = require("../validators/step-validator");
class Step {
    constructor() {
        this.canAddStep = true;
    }
    async getValidStepOutput(input) {
        try {
            const output = await this.getStepOutput(input);
            (0, step_validator_1.validateStepOutput)(input, output);
            return {
                ...output,
                name: this.config.name,
                description: this.config.description,
            };
        }
        catch (err) {
            if (!(err instanceof Error)) {
                throw err;
            }
            throw new Error(`${this.config.name} step is invalid. ${err.message}`);
        }
    }
    getValidInputERC20Amount(inputERC20Amounts, filter, amount) {
        const { erc20AmountsForStep, unusedERC20Amounts } = (0, filters_1.filterERC20AmountInputs)(inputERC20Amounts, filter);
        const numFiltered = erc20AmountsForStep.length;
        if (numFiltered === 0) {
            throw new Error(`No step inputs match filter.`);
        }
        if (numFiltered > 1) {
            throw new Error(`Expected one erc20 amount for step input - received ${numFiltered}.`);
        }
        const erc20AmountForStep = { ...erc20AmountsForStep[0] };
        const hasNonDeterministicInput = erc20AmountForStep.expectedBalance !== erc20AmountForStep.minBalance;
        if ((this.config.hasNonDeterministicOutput ?? false) &&
            hasNonDeterministicInput) {
            throw new Error(`Non-deterministic step must have deterministic inputs - you may not stack non-deterministic steps in a single recipe.`);
        }
        if ((0, shared_models_1.isDefined)(amount)) {
            if (hasNonDeterministicInput) {
                throw new Error('Cannot specify amount for step if it has non-deterministic inputs.');
            }
            if (amount > erc20AmountForStep.expectedBalance) {
                throw new Error(`Specified amount ${amount} exceeds balance ${erc20AmountForStep.expectedBalance}.`);
            }
        }
        const changeOutputs = this.getChangeOutputs(erc20AmountForStep, amount);
        if (changeOutputs) {
            unusedERC20Amounts.push(changeOutputs.changeOutput);
            erc20AmountForStep.expectedBalance = changeOutputs.expectedBalance;
            erc20AmountForStep.minBalance = changeOutputs.minBalance;
        }
        return { erc20AmountForStep, unusedERC20Amounts };
    }
    getValidInputNFTAmount(inputNFTAmounts, filter) {
        const { nftAmountsForStep, unusedNFTAmounts } = (0, filters_1.filterNFTAmountInputs)(inputNFTAmounts, filter);
        const numFiltered = nftAmountsForStep.length;
        if (numFiltered === 0) {
            throw new Error(`No step inputs match filter.`);
        }
        if (numFiltered > 1) {
            throw new Error(`Expected one NFT amount for step input - received ${numFiltered}.`);
        }
        const nftAmountForStep = { ...nftAmountsForStep[0] };
        return { nftAmountForStep, unusedNFTAmounts };
    }
    getChangeOutputs(erc20AmountForStep, amountUsed) {
        if (!(0, shared_models_1.isDefined)(amountUsed) ||
            amountUsed >= erc20AmountForStep.expectedBalance) {
            return undefined;
        }
        const changeBalance = erc20AmountForStep.expectedBalance - amountUsed;
        const changeOutput = {
            ...erc20AmountForStep,
            expectedBalance: changeBalance,
            minBalance: changeBalance,
        };
        return {
            expectedBalance: amountUsed,
            minBalance: amountUsed,
            changeOutput,
        };
    }
    getValidInputERC20Amounts(inputERC20Amounts, filters, amountsPerAddress) {
        const anyFilterPasses = (erc20Amount) => {
            return (filters.find(filter => {
                return filter(erc20Amount);
            }) != null);
        };
        const { erc20AmountsForStep, unusedERC20Amounts } = (0, filters_1.filterERC20AmountInputs)(inputERC20Amounts, anyFilterPasses);
        const numFiltered = erc20AmountsForStep.length;
        if (numFiltered !== filters.length) {
            throw new Error(`Step input does not include a balance for each filtered token.`);
        }
        erc20AmountsForStep.forEach(erc20AmountForStep => {
            const amount = amountsPerAddress[erc20AmountForStep.tokenAddress];
            if (!amount) {
                return;
            }
            const changeOutputs = this.getChangeOutputs(erc20AmountForStep, amount);
            if (changeOutputs) {
                unusedERC20Amounts.push(changeOutputs.changeOutput);
                erc20AmountForStep.expectedBalance = changeOutputs.expectedBalance;
                erc20AmountForStep.minBalance = changeOutputs.minBalance;
            }
        });
        return { erc20AmountsForStep, unusedERC20Amounts };
    }
}
exports.Step = Step;
